module.exports = __webpack_public_path__ + "static/media/legal-s.2c1b343b.jpg";